// extracted by mini-css-extract-plugin
export var actions = "_1e-0";
export var actionsContainer = "_1e-6";
export var border = "_1e-1";
export var childFullHeight = "_1e-d";
export var collapse = "_1e-2";
export var content = "_1e-8";
export var contentChild = "_1e-c";
export var fullscreen = "_1e-a";
export var hasLeftRadius = "_1e-h";
export var headerContainer = "_1e-3";
export var headerRow = "_1e-5";
export var hidePadding = "_1e-9";
export var navCollapsedGap = "_1e-i";
export var noScrollX = "_1e-j";
export var noScrollY = "_1e-k";
export var optOutTopPadding = "_1e-b";
export var pageMain = "_1e-g";
export var pageOuter = "_1e-e";
export var pagePadding = "_1e-7";
export var profile = "_1e-l";
export var profileContainer = "_1e-m";
export var profileImage = "_1e-n";
export var profileMain = "_1e-o";
export var profileSubtitle = "_1e-q";
export var profileTitle = "_1e-p";
export var showLeftPadding = "_1e-f";
export var tabsWrapper = "_1e-4";
export var title = "_1e-r";